import styled from 'styled-components';
import { BlueButton } from '../../../utils/atoms';
import {
  silver, blue, openSansLight, grey, darkerGrey, openSans,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

export const FormButton = styled(BlueButton)`
  font-size: 47px;
  display: inline-block;
`;

export const FormStyles = styled.div`
   
    overflow: hidden;
    
    .wrapper {
        margin: 5em auto;
        padding: 30px;
        width: 350px;
        text-align: center;
        border: 1px solid ${silver};
      
        @media(max-width: ${mobile.max}px) {
            width: 100%;
            padding: 30px;
            border: none;
        }
    }

    .logo {
        text-align: center;
        padding-top: 30px;

        img {
            display: inline-block;
            width: 150px;
        }
    }

    input {
        display: block;
        padding: 10px;
        margin: 40px auto;
        padding: 0 0 14px 0;
        width: 100%;
        max-width: 250px;
        height: 54px;
        border-bottom: 1px solid ${blue};
        ${openSansLight}
        font-size: 38px;
        color: ${blue};
        text-align: center;

        &::placeholder {
            ${openSansLight}
            font-size: 38px;
            color: ${grey};
        }

        @media(max-width: ${mobile.max}px) {
            font-size: 20px;
            height: auto;
            padding-bottom: 7px;

            &::placeholder {
            font-size: 20px;
            }
        }
    }

    span {
        display: inline-block;
        margin-top: 20px;
        ${openSans}
        color: ${darkerGrey}
    }
`;



// WEBPACK FOOTER //
// ./src/components/protection/styles/protection.style.js